export const menuItems = {
  features: {
    generateVideos: [
      {
        title: "Reddit Story Videos",
        href: "https://crayo.ai/features/reddit-story",
        description: "Create reddit-style story videos in seconds with our AI script generator",
      },
      {
        title: "Split Screen Videos",
        href: "https://crayo.ai/features/split-screen",
        description: "Create split-screen video with our AI script generator",
      },
      {
        title: "Fake Text Stories",
        href: "https://crayo.ai/features/fake-texts",
        description: "Create fake text conversation videos for Instagram, TikTok, and Shorts",
      },
      {
        title: "Veo-3 Style Video",
        href: "https://crayo.ai/features/veo3",
        description: "Create viral Veo-3 style videos with just a few clicks",
      },
    ],
    tools: [
      { title: "Audio Balancer", href: "https://crayo.ai/features/free/audio-balancer" },
      { title: "Video Compressor", href: "https://crayo.ai/features/free/video-compressor" },
      { title: "MP3 Converter", href: "https://crayo.ai/features/free/mp3-converter" },
    ],
  },
  resources: [
    {
      title: "Affiliate Program",
      href: "https://crayo.tolt.io/login",
      description: "Earn 20% on all paid referrals to Crayo.",
    },
    {
      title: "Community Discord",
      href: "https://crayo.ai/discord",
      description: "Join for customer support and feedback.",
    },
  ],
};
